import React from "react";
import PropTypes from 'prop-types';

function BlockIcon({ className, color = '#a5a5a5' }) {
  return (
    <div className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
        <g fill="none" stroke={color} strokeWidth="1.75">
          <circle cx="7" cy="7" r="7" stroke="none"/>
          <circle cx="7" cy="7" r="6.125" fill="none"/>
        </g>
        <line x1="9.026" y2="9.026" transform="translate(2.036 2.938)" fill="none" stroke={color} strokeWidth="1.75"/>
      </svg>
    </div>
  )
}

BlockIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default BlockIcon;



// WEBPACK FOOTER //
// ./src/components/icons/BlockIcon.jsx